// types
import { IRedemptionErrorMessageKeys } from 'types/redemption';

// constants
import { ERROR_TEXT_KEYS, REDEMPTION_STATUS } from '../redemption.constants';
import { ERROR_KEYS } from 'constants/app.constants';

export const ERROR_MESSAGE_KEYS: IRedemptionErrorMessageKeys = {
    CODE_ALREADY_REDEEMED: ERROR_TEXT_KEYS.ERROR_CODE_ALREADY_REDEEMED,
    USER_ALREADY_REDEEMED: ERROR_TEXT_KEYS.ERROR_USER_ALREADY_REDEEMED,
    GENERIC_ERROR: ERROR_KEYS.WIDGET_ERROR_MESSAGE,
    INVALID_CODE: ERROR_TEXT_KEYS.ERROR_INVALID_CODE,
    NOT_ELIGIBLE_BY_COUNTRY: ERROR_TEXT_KEYS.ERROR_NOT_ELIGIBLE,
    AGE_RESTRICTION: ERROR_TEXT_KEYS.ERROR_REQUIREMENTS_NOT_MET,
    PROFILE_NOT_LINKED: ERROR_TEXT_KEYS.ERROR_PROFILE_NOT_LINKED,
    MAINTENANCE_ERROR: ERROR_TEXT_KEYS.ERROR_MAINTENANCE
};

export const trackingFlowStepDetailsOptions = {
    [REDEMPTION_STATUS.GENERIC_ERROR]: 'something went wrong',
    [REDEMPTION_STATUS.MAINTENANCE_ERROR]: 'maintenance',
    [REDEMPTION_STATUS.NOT_ELIGIBLE]: 'not eligible',
    [REDEMPTION_STATUS.AGE_RESTRICTION]: 'not eligible',
    [REDEMPTION_STATUS.CODE_ALREADY_REDEEMED]: 'already claimed',
    [REDEMPTION_STATUS.USER_ALREADY_REDEEMED]: 'already claimed',
    [REDEMPTION_STATUS.INVALID_CODE]: 'something went wrong'
};

export const trackingFlowStepInitialData = {
    flowStep: 'error',
    action: 'error : something went wrong',
};

export const trackingFlowStepOnClickAnotherCodeBtnOptions = {
    ...trackingFlowStepInitialData,
    flowStep: 'error',
    flowStepDetails: trackingFlowStepDetailsOptions[REDEMPTION_STATUS.GENERIC_ERROR],
    action: 'error : submit another code'
};
